<template>
  <div class="container">
    <div v-show="alerta" class="alert alert-danger text-center" role="alert">
      El código no se ha encontrado para generar un documento PDF.
    </div>
  </div>

</template>

<script>
import html2pdf from 'html2pdf.js';
import logo from '../assets/autocom/logo_autocom_credit.png';
import logo_web from '../assets/goriders/logo_web.png';
import logo_financiera from '../assets/goriders/logo_financiera.png'

export default {
  name: 'GoRiders',

  components: {

  },
    data() {
    return {

        alerta: false,

      //Prod
       serverComunicaciones: 'https://comunicaciones.autocom.mx/api',

      //QA
      // serverComunicaciones: 'https://qa-comunicaciones.autocom.mx/api',

        uuid: this.$route.query.uuid
      };
  },

  methods: {

      tokenComunicaciones(){
          let user = {usuario: "Comunicaciones", password: "C0mun1c4c10n35"};
          axios.post(this.serverComunicaciones + "/auth", user)
          .then((response) => {
            //console.log("token stock-->", response.data.token);
            sessionStorage.setItem("tokenComunicacion", response.data.token);
            this.consultaUuid();
          })
          .catch((error) => {
            console.log(error.message);
          });
    },

    consultaUuid(){
      //console.log("Consulta Uuid");

      let body = {
          referencia: this.uuid
        };

      axios.post(this.serverComunicaciones + "/infoPdfFin",body, 
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenComunicacion"),
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {

          if (response.status == 204) {
            this.alerta = true;
          } else {
            this.fecha = response.data[0].fecha_registro,
            this.enganche= "$"+this.formatPrice(response.data[0].data_json.AditionalInfo.Downpayment),
            this.mCredito= "$"+this.formatPrice(response.data[0].data_json.AditionalInfo.AmountToFinance),
            this.plazo= response.data[0].data_json.AditionalInfo.Installments,
            this.mensualidad= "$"+this.formatPrice(response.data[0].data_json.AditionalInfo.Couta),
            this.seguro= response.data[0].data_json.Seguro,
            this.uso= response.data[0].data_json.TipoUso,
            this.garantia = response.data[0].data_json.Garantia,
            this.agencia = response.data[0].data_json.NombreAgencia
            
            let fechaStr = this.fecha;
            let fecha = parseFecha(fechaStr);
            fecha.setDate(fecha.getDate() + 4);
            let fechaNueva = formatFecha(fecha);
            this.oferta = fechaNueva;

            function parseFecha(fechaStr) {
                const partes = fechaStr.split('/');
                const dia = parseInt(partes[0], 10);
                const mes = parseInt(partes[1], 10) - 1;
                const año = parseInt(partes[2], 10);
                return new Date(año, mes, dia);
            }

            function formatFecha(fecha) {
                const dia = fecha.getDate().toString().padStart(2, '0');
                const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
                const año = fecha.getFullYear();
                return `${dia}/${mes}/${año}`;
            }

            if ( this.garantia == "No lo deseo") {
              this.extension = "No";
            } else {
              this.extension = "Si";
            }

            this.generar();
          }

        })
        .catch((error) => {
          console.log(error);
        });
    },

    generar() {
      console.log('generar');
      setTimeout(() => {
        this.generatePDF();
      }, 10);
    },

    setTime() {
      setTimeout(() => {
        window.close();
      }, 10);
    },

    generatePDF() {
      const element = `
           <!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN" "http://www.w3.org/TR/html4/loose.dtd">
            <html>
            <head>
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
            <!-- utf-8 works for most cases -->
            <meta name="viewport" content="width=device-width">
            <!-- Forcing initial-scale shouldn't be necessary -->
            <meta http-equiv="X-UA-Compatible" content="IE=edge">
            <!-- Use the latest (edge) version of IE rendering engine -->
            <title>Creación de usuarios</title>
              <link rel="preconnect" href="https://fonts.googleapis.com">
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
            <link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet">
              <style>
              .credit-simulation {
                background-color: #e5e5e5;
                display: flex;
                flex-direction: column;
                overflow: hidden;
                padding: 16px 26px 5px;
              }

              .header-container {
                display: flex;
                gap: 20px;
              }

              .logo-column {
                display: flex;
                flex-direction: column;
                line-height: normal;
                width: 55%;
              }

              .logo-content {
                display: flex;
                flex-grow: 1;
                flex-direction: column;
                align-items: flex-start;
                font-family: Montserrat, sans-serif;
                color: #000;
                font-weight: 700;
                text-transform: uppercase;
              }

              .logo-image {
                width: 118px;
                height: 24px;
                object-fit: contain;
                object-position: center;
                max-width: 100%;
              }

              .simulation-title {
                font-size: 20px;
                align-self: stretch;
                    margin-block-start: .5em;
                  margin-block-end: .5em;
              }

              .agency-name {
                font-size: 12px;
                margin-top: 30px;
              }

              .date-column {
                display: flex;
                flex-direction: column;
                line-height: normal;
                width: 45%;
                margin-left: 20px;
              }

              .date-content {
                display: flex;
                margin-top: 4px;
                flex-grow: 1;
                flex-direction: column;
                color: #000;
                text-transform: uppercase;
                font: 700 12px Montserrat, sans-serif;
              }

              .date-logo {
                width:148px;
                height: 18px;
                aspect-ratio: 5.1;
                object-fit: contain;
                object-position: center;
                align-self: flex-end;
              }

              .request-date {
                margin-top: 55px;
              }

              .car-title {
                color: #000;
                align-self: flex-start;
                margin-top: 10px;
                font: 700 32px Montserrat, sans-serif;
                margin-bottom: 0px;
              }

              .car-details {
                color: #6b6b6b;
                align-self: flex-start;
                font: 700 18px Montserrat, sans-serif;
                margin-top: 5px;
              }

              .finance-details {
                display: flex;
                margin-top: 10px;
                gap: 7px;
                font-family: Montserrat, sans-serif;
                color: #000;
                font-weight: 700;
                flex-wrap: wrap;
              }

              .finance-box {
                border-radius: 4px;
                background-color: #fff;
                box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                flex: 1;
                flex-grow: 1;
                flex-basis: 0;
                width: fit-content;
                padding: 8px 39px 8px 12px;
              }

              .finance-label {
                font-size: 12px;
              }

              .finance-amount {
                font-size: 32px;
                margin-top: 8px;
              }

              .down-payment-box {
                border-radius: 4px;
                background-color: #fff;
                box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                white-space: nowrap;
                flex: 1;
                flex-grow: 1;
                flex-basis: 0;
                width: fit-content;
                padding: 8px 55px 8px 11px;
              }

              .payment-details {
                display: flex;
                margin-top: 8px;
                gap: 7px;
                font-family: Montserrat, sans-serif;
                color: #000;
                font-weight: 700;
                flex-wrap: wrap;
              }

              .term-box {
                border-radius: 4px;
                background-color: #fff;
                box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                flex: 1;
                flex-grow: 1;
                flex-basis: 0;
                width: fit-content;
                padding: 8px 40px 8px 12px;
              }

              .term-label {
                font-size: 10px;
              }

              .term-value {
                font-size: 32px;
                margin-top: 7px;
              }

              .monthly-payment-box {
                border-radius: 4px;
                background-color: #fff;
                box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                flex: 1;
                flex-grow: 1;
                flex-basis: 0;
                width: fit-content;
                padding: 8px 55px 8px 11px;
              }

              .additional-info {
                border-radius: 8px;
                background-color: #fff;
                box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
                margin-top: 11px;
                padding: 16px 9px;
              }

              .info-container {
                gap: 20px;
                display: flex;
              }

              .info-column {
                display: flex;
                flex-direction: column;
                line-height: normal;
                width: 50%;
              }

              .info-content {
                display: flex;
                width: 100%;
                flex-direction: column;
                color: #fff;
                font: 700 12px Montserrat, sans-serif;
              }

              .info-label {
                align-self: stretch;
                background-color: #2f2f2f;
                min-height: 25px;
                white-space: nowrap;
                text-transform: uppercase;
                padding: 0 0 10px 15px;
              }

              .info-value {
                color: #000;
                font-size: 12px;
                align-self: flex-start;
                margin-top: 10px;
              }

              .reminder-text {
                color: #2f2f2f;
                letter-spacing: -0.28px;
                text-align: center;
                align-self: center;
                margin-top: 20px;
                font: 700 14px Montserrat, sans-serif;
              }

              .offer-validity {
                color: #000;
                text-align: center;
                align-self: center;
                margin-top: 5px;
                width: 328px;
                font: 400 10px/15px Montserrat, sans-serif;
              }

              .logo-footer {
                aspect-ratio: 5.75;
                object-fit: contain;
                object-position: center;
                width: 201px;
                align-self: center;
                margin-top: 5px;
                max-width: 100%;
              }

              .footer-text {
                color: #696969;
                text-align: center;
                align-self: center;
                margin-top: 15px;
                font: 500 14px Montserrat, sans-serif;
              }

              .visually-hidden {
                position: absolute;
                width: 1px;
                height: 1px;
                margin: -1px;
                padding: 0;
                overflow: hidden;
                clip: rect(0, 0, 0, 0);
                white-space: nowrap;
                border: 0;
              }
              </style>
              </head>
              <section class="credit-simulation">
                <header class="header-container">
                  <div class="logo-column">
                    <div class="logo-content">
                      <img src="${logo_web}" alt="Company Logo" class="logo-image" />
                      <h1 class="simulation-title">SIMULACIÓN DE CRÉDITO</h1>
                      <p class="agency-name">AGENCIA: ${this.agencia.toUpperCase()}</p>
                    </div>
                  </div>
                  <div class="date-column">
                    <div class="date-content">
                      <img src="${logo}" alt="Date Logo" class="date-logo" />
                      <p class="request-date">Fecha de solicitud: ${this.fecha}</p>
                    </div>
                  </div>
                </header>
                <div class="finance-details">
                  <div class="finance-box">
                    <p class="finance-label" style="margin-bottom: 0px;">Monto a financiar</p>
                    <p class="finance-amount" style="margin-bottom: 5px;">${this.mCredito}*</p>
                  </div>
                  <div class="down-payment-box">
                    <p class="finance-label" style="margin-bottom: 0px;">Enganche</p>
                    <p class="finance-amount" style="margin-bottom: 5px;">${this.enganche}</p>
                  </div>
                </div>

                <div class="payment-details">
                  <div class="term-box">
                    <p class="term-label" style="margin-bottom: 0px;">Plazo / Meses</p>
                    <p class="term-value" style="margin-bottom: 5px;">${this.plazo}</p>
                  </div>
                  <div class="monthly-payment-box">
                    <p class="finance-label" style="margin-bottom: 0px;">Mensualidad deseada</p>
                    <p class="finance-amount" style="margin-bottom: 5px;">${this.mensualidad}</p>
                  </div>
                </div>

                <div class="additional-info">
                  <div class="info-container">
                    <div class="info-column">
                      <div class="info-content">
                        <p class="info-label" style="margin-top:0px;padding-top:10px">Seguro</p>
                        <p class="info-value" style="margin-top:0px;padding: 0px 15px;">${this.seguro}</p>
                        <p class="info-label" style="padding-top:10px">Garantía extendida</p>
                        <p class="info-value" style="margin-top:0px;padding: 0px 15px;">${this.extension}</p>
                      </div>
                    </div>
                    <div class="info-column">
                      <div class="info-content">
                        <p class="info-label" style="margin-top:0px;padding-top:10px">USO DEL VEHÍCULO</p>
                        <p class="info-value" style="margin-top:0px;padding: 0px 15px;">${this.uso}</p>
                        <p class="info-label" style="padding-top:10px">PLAZO DE GARANTÍA ETENDIDA</p>
                        <p class="info-value" style="margin-top:0px;padding: 0px 15px;">${this.garantia}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="reminder-text">Recuerda que para solicitar tu crédito automotriz, continúa en el enlace enviado a tu
                  correo electrónico desde tu dispositivo móvil.</p>

                <p class="offer-validity" style="font-size: 12px;"><strong>*Esta oferta es válida al
                    ${this.oferta}</strong><br /><strong>Aplican reestricciones</strong></p>

                <img src="${logo_financiera}" alt="Footer Logo" class="logo-footer" />

                <p class="footer-text">*Este es un monto aproximado, los accesorios, seguros y adicionales no están considerados.
                  Para dudas en tu proceso recuerda contactarnos en cualquier momento al teléfono: <strong>800 400 0274</strong> o
                  vía correo electrónico en <strong>atencion@clikautofinance.com</strong> de Lunes a Viernes de 8 am a 9 pm o Sábado de 9 am a 2 pm.</p>
              </section>
              </html>
      `

      const options = {
        margin: 1,
        filename: 'GoRiders.pdf',
        // image: { type: 'jpeg', quality: 1 },
        // html2canvas: { scale: 2, useCORS: true },
        // jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' }
        image:        { type: 'jpeg', quality: 0.98 },
        html2canvas:  { scale: 2 },
        jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
      };

      html2pdf().set(options).from(element).toPdf().output('blob').then(function (blob) {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'GoRiders.pdf';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      });
    },

    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },


  },

  created() {
    //this.setTime();
    this.tokenComunicaciones();
   },

}
</script>

<style scoped>

</style>